import React from 'react';
import { motion } from 'framer-motion';
import { Brain, HeartCrack, Clock } from 'lucide-react';
const reasons = [{
  icon: Brain,
  title: 'No es falta de madurez',
  description: 'Es tu cerebro procesando el rechazo social en las mismas áreas que el dolor físico real.'
}, {
  icon: HeartCrack,
  title: 'No es que seas "intens@"',
  description: 'Es la química de la dopamina y la oxitocina buscando un cierre que nunca te dieron.'
}, {
  icon: Clock,
  title: 'No es una tontería',
  description: 'Es el duelo por un futuro que imaginaste y que la sociedad no te da permiso de llorar.'
}];
export function Empathy() {
  return <section className="py-24 md:py-32 bg-dark-800 relative overflow-hidden" data-id="element-31">
      {/* Subtle background blob */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-brand-muted/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3 pointer-events-none" data-id="element-32"></div>

      <div className="container mx-auto px-6 relative z-10" data-id="element-33">
        <div className="max-w-4xl mx-auto text-center mb-20" data-id="element-34">
          <motion.h2 className="text-5xl md:text-7xl mb-6" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} data-id="element-35">
            ¿POR QUÉ DUELE TANTO SI{' '}
            <span className="text-brand-muted" data-id="element-36">"NO ERAN NADA"</span>?
          </motion.h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-37">
          {reasons.map((reason, index) => <motion.div key={index} className="p-8 rounded-2xl bg-dark-700/50 border border-dark-600 hover:border-dark-500 transition-colors" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} data-id="element-38">
              <div className="w-12 h-12 rounded-full bg-dark-600 flex items-center justify-center mb-6 text-brand-muted" data-id="element-39">
                <reason.icon className="w-6 h-6" data-id="element-40" />
              </div>
              <h3 className="text-2xl font-heading tracking-wide mb-4" data-id="element-41">
                {reason.title}
              </h3>
              <p className="text-brand-muted leading-relaxed font-light" data-id="element-42">
                {reason.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}